import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StateControllerService} from '../../api';
import {StateConfigService} from '../state/state-config.service';

export interface VersionHistoryEntry {
  version: string;
  commitSha: string;
  title: string | null;
  rawNotes: string;
  createdAt: string;
  betaPublishedAt: string | null;
  livePublishedAt: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class VersionHistoryService {
  private httpClient = inject(HttpClient);
  private stateControllerService = inject(StateControllerService);
  private stateConfigService = inject(StateConfigService);

  // Reuses the basePath any generated API service already resolved at build/runtime -
  // same approach as SseService, since this endpoint isn't part of the generated OpenAPI client.
  private get basePath(): string {
    return (this.stateControllerService as any).basePath ?? '';
  }

  getEntries(): Observable<VersionHistoryEntry[]> {
    const env = this.stateConfigService.stage === 'live' ? 'live' : 'beta';
    return this.httpClient.get<VersionHistoryEntry[]>(`${this.basePath}/version-history`, {
      params: {env}
    });
  }
}
